<ng-container *ngIf="defaultIcon.length">
  <inline-view-loader [isLoading]="isLoading" [hasText]="hasText"></inline-view-loader>
  <fa-icon *ngIf="!isLoading" [icon]="defaultIcon" aria-hidden="true" [ngClass]="{'mr-1': hasMarginClass}"></fa-icon>
  <ng-content></ng-content>
</ng-container>